/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import CreateWorkspaceButton from 'ui/components/CreateWorkspaceButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';


// Mixins
import listing from 'ui/mixins/workspaces/listing';
import searchable from 'ui/mixins/workspaces/searchable-event';
import restorable from 'ui/mixins/workspaces/restorable';

// Utils
import { get } from 'lodash';

/**
 * This component is the main EventsList page controller.
 *
 * @category ui.pages
 * @exports EventsList
 * @component
 */
const __vue_script__ = {
    name: 'EventsList',

    components: { CreateWorkspaceButton, SearchBar },

    mixins: [listing, searchable, restorable],

    data() {
        const user = this.$services.user.getCurrentUser();
        return {
            canCreate: user.orgs.some(
                org => this.$services.user.hasPermission(
                    'global_actions.create_event',
                    { org_id: org._id }
                )
            ),
            currentStage: 'all',
            events: {},
            hasWorkspaces: false,
            visibleEvents: {}
        };
    },

    async created() {
        const { accessed_eid: accessedEid } = this.$router.getSearchParams();

        this.$router.setSearchParams({});

        try {
            const latestEventIds = this.$services.event
                .getLastAccessed(this.$cookies, this.$services.storage)
                // Only get last 8 accessed events
                .slice(0, 8);

            this.events = await this.$services.user.getUserEventsGrouped(latestEventIds);
            this.hasWorkspaces = Object.values(this.events).flat().length !== 0;
            this.resetSearch();
        } catch (error) {
            console.error('[EventsList] An error occurred while loading user events');
            this.$services.crashReporting.captureException(error);
            this.hasWorkspaces = false;
        }

        if (accessedEid) {
            try {
                const workspace = await this.$services.event.getEvent(accessedEid);
                const stage = get(workspace, 'lifecycle.stage');

                if (stage === 'archived') {
                    this.openRestoreModal(workspace);
                } else if (stage === 'destroyed') {
                    this.$alert.show('events.errors.deleted', null, { buttonClasses: ['primary'] });
                }
            } catch (error) {
                const code = get(error, 'response.status') || 500;

                if (code >= 400 && code < 500) {
                    this.$alert.show('events.errors.unathorized_or_not_found', null, { buttonClasses: ['primary'] });
                }
            }
        }

        this.loading = false;
    },

    methods: {
        /**
         * Given a stage this method determines if it should be visible or not
         *
         * @param {String} stage the stage to check visibility for
         *
         * @returns {Boolean} whether to show the specified stage or not
         */
        showStage(stage) {
            if (stage === 'latest') {
                return this.searchTerm.length === 0 && this.currentStage === 'all';
            }

            return this.visibleEvents[stage].length !== 0 && [stage, 'all'].includes(this.currentStage);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page",attrs:{"status":_vm.loading}},[_c('section',{staticClass:"page-content events-page"},[(_vm.hasWorkspaces)?_c('div',{staticClass:"search"},[(_vm.canCreate)?_c('create-workspace-button',{staticClass:"create",attrs:{"modal-classes":"medium","buttonKey":"events.create"}}):_vm._e(),_c('search-bar',{attrs:{"results":_vm.hasResults},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('div',{staticClass:"btn-group actions"},_vm._l((['all', 'live', 'future', 'past']),function(stage){return _c('button',{staticClass:"btn",class:{ primary: _vm.currentStage === stage },attrs:{"disabled":_vm.visibleEvents[stage] && _vm.visibleEvents[stage].length === 0},on:{"click":function($event){_vm.currentStage = stage}}},[_vm._v(" "+_vm._s(_vm.$t(("events." + stage))))])}),0)])],1):_vm._e(),(_vm.hasResults || _vm.hasWorkspaces)?_c('div',{staticClass:"section-list"},_vm._l((Object.keys(_vm.visibleEvents)),function(stage){return (_vm.showStage(stage))?_c('workspaces-list',{key:stage,class:stage,attrs:{"workspaces":_vm.visibleEvents[stage],"uid-prefix":stage,"highlightArchived":_vm.canSeeArchived},on:{"click":_vm.checkLifecycle}},[_c('h4',{staticClass:"separator"},[_vm._v(_vm._s(_vm.$t(("events." + stage))))])]):_vm._e()}),1):_vm._e(),(!_vm.hasWorkspaces)?_c('div',{staticClass:"no-data"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.$utils.assets.imagePath('workspace-start.svg')),expression:"$utils.assets.imagePath('workspace-start.svg')"}],attrs:{"alt":_vm.$t('events.welcome')}}),_c('h1',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$t('events.welcome')))]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('events.empty')))]),(_vm.canCreate)?_c('create-workspace-button',{attrs:{"modal-classes":"medium"}}):_vm._e(),_c('br'),_c('a',{attrs:{"href":_vm.gettingStartedUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('events.getting_started')))])],1):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__